import '@passageidentity/passage-elements/passage-auth'
import { PassageUser } from '@passageidentity/passage-elements/passage-user'
import { useEffect, useState } from 'react'
import isLocalDev from "../lib/isLocalDev";
import apiClient from "../lib/apiClient";

const DISABLED = false

// if the window is localhost, use the development app id
const APP_ID = isLocalDev() ?
  "ObnZXTGcUA0WiYwh1O7YUdaE" : "tCL41SjHF8lzCqaxDtiQQLBa"

export default function PassageAuth({ children }) {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // short circuit only allowed in dev mode
    if (DISABLED && isLocalDev()) return;

    const checkUser = async () => {
      try {
        const user = new PassageUser();
        const userInfo = await user.userInfo();
        await apiClient.get("/api/family_office");
        setUserInfo(userInfo);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setLoading(false);
      }
    };

    checkUser();
  }, []);

  if (DISABLED) return children

  if (loading) return ""
  if (userInfo) return children
  return <Login />
}

export function Login() {
  if (DISABLED) return ""

  return (
    <div className="d-flex align-items-stretch justify-content-center mt-6">
      <div className="p-4 card align-items-center" >
        <img className='card-img-top'
          src="/assets/img/prosperity-logo.webp"
          alt="Prosperity Logo"
          style={{ width: '256px', height: '256px' }} />

        <div className="card-body">
          <h1>Prosperity</h1>
          <p>Private beta.</p>
        </div>
      </div>
      <div className="card p-4" >
        <passage-auth app-id={APP_ID} />
      </div>
    </div>
  )
}

export function Logout() {
  const user = new PassageUser()
  user.signOut().then(() => {
    window.location = "/login"
  });
  return "";
}